<template>
    <div class="comment-form">

        <div class="content-title">
            Ответить
        </div>
        <form @submit.prevent="submit">
            <div class="comment-form__first-row">
                <div class="comment-form__block">
                    <div :class="{'active': commentErrors.name}" class="comment-error">
                        <div v-for="err in commentErrors.name">
                            {{ err }}
                        </div>
                    </div>
                    <span>Ваше Имя</span>
                    <input v-model="name" type="text">
                </div>
                <div class="comment-form__block">
                    <div :class="{'active': commentErrors.email}" class="comment-error">
                        <div v-for="err in commentErrors.email">
                            {{ err }}
                        </div>
                    </div>
                    <span>Ваш Email</span>
                    <input v-model="email" type="text">
                </div>
            </div>
            <div class="comment-form__second-row">
                <div class="comment-form__block">
                    <div :class="{'active': commentErrors.body}" class="comment-error">
                        <div v-for="err in commentErrors.body">
                            {{ err }}
                        </div>
                    </div>
                    <span>Сообщение</span>
                    <textarea v-model="body" cols="30" rows="10"></textarea>
                </div>
            </div>
            <button type="submit" class="form-submit">Отправить</button>
        </form>
    </div>
</template>

<script>
import {mapGetters} from "vuex";
import {ajax, apiUrls} from "../store/urls";

export default {
    props: ["slug"],
    name: "comment-form",
    data() {
        return {
            name: '',
            email: '',
            body: '',
            type: '',
        }
    },
    methods: {
        submit() {
            ajax
                .post(apiUrls.addCommentUrl(this.type, this.slug), {
                    name: this.name,
                    body: this.body,
                    email: this.email,
                    url: window.location.href
                })
                .then(response => {
                    this.$store.commit('addToComments', response.data);
                    this.name = '';
                    this.email = '';
                    this.body = '';
                })
                .catch(err => {
                    this.$store.commit('setData', {key: 'commentErrors', value: err.response.data, module: 'home'});
                    setTimeout(() => {
                        this.$store.commit('setData', {key: 'commentErrors', value: {}, module: 'home'});
                    }, 3000)
                });
        },
    },
    computed: {
        ...mapGetters(["newsDetail", "commentErrors"])
    },
    mounted() {
        switch (this.$route.name) {
            case 'offerDetail':
                this.type = "offers";
                break;
            case 'articleDetail':
                this.type = "news";
        }
    }
}
</script>

<style lang="scss" scoped>
.comment-form {

    form {
        display: flex;
        justify-content: space-between;
        flex-wrap: wrap;

        .form-submit {
            background-color: #006688;
            width: 100px;
            color: #ffffff;
            text-align: left;
            font-size: 15px;
            padding: 10px;
            margin: 15px 0 15px auto;

            &:disabled {
                cursor: not-allowed;
            }
        }
    }

    &__block {
        width: 400px;
        display: flex;
        flex-direction: column;
        text-align: left;
        position: relative;

        span {
            display: block;
            color: #909090;
            margin-top: 10px;
            margin-bottom: 10px;
        }

        input, textarea {
            padding: 11px 18px;
            color: #000;
            margin: 0;
            background: #F0F0F0;
            border: none;
            border-top: 1px solid #E0E0E0;
        }

        textarea {
            height: 100%;
        }
    }

    &__second-row {
        textarea {
            height: 100%;
        }
    }
}

.comment-error {
    position: absolute;
    font-size: 12px;
    line-height: 1;
    top: -7px;
    right: 20px;
    max-width: 280px;
    min-width: 50px;
    background: #E9431C;
    font-family: arial, sans-serif;
    color: #FFF;
    padding: 10px 20px 10px 20px;
    transition: .5s ease;
    visibility: hidden;
    opacity: 0;

    &:after {
        content: '';
        display: block;
        width: 0;
        height: 0;
        border-left: 7px solid transparent;
        border-right: 7px solid transparent;
        border-top: 7px solid #E9431C;
        position: absolute;
        bottom: -7px;
        left: 50%;
    }
}

.comment-error.active {
    animation: hovering 3s forwards;
}

@media screen and (max-width: 950px) {
    .comment-form {
        &__block {
            width: 70%;
        }

        form {
            flex-direction: column;
            justify-content: center;

            .form-submit {
                margin-right: auto;
            }
        }
    }
}

@media screen and (max-width: 768px) {
    .comment-form {
        &__block {
            width: 90%;
        }
    }
}

@media screen and (max-width: 350px) {
    .comment-form {
        &__block {
            width: 100%;
        }
    }
}
</style>
